<template>
  <div class="shop-order-contact-section">
    <section
      v-for="(customer, index) in supportCustomers"
      :key="'support-' + index"
      class="order-card"
    >
      <div class="section-title">{{ getCustomerTitleFn(customer, index, 'support') }}</div>
      <div class="form-grid">
        <template v-for="field in getVisibleCustomFieldsFn(customer.cus_type)">
          <div
            v-if="getFieldModeFn(field.config, field.key) !== 'country_cities' && !isContactPhoneFieldFn(customer, field.key) && !isContactAppFieldFn(customer, field.key) && !shouldSkipSupportFieldFn(customer, field.key)"
            :key="'support-field-' + index + '-' + field.key"
            class="form-item"
            :class="{ 'form-item--full': isWideFieldFn(field.key) }"
          >
            <label>{{ getFieldLabelFn(field.key, field.config) }}<span v-if="isRequiredFn(field.config)" class="required">*</span></label>

          <el-input
            v-if="getFieldModeFn(field.config, field.key) === 'text'"
            v-model.trim="customer[field.key]"
            :placeholder="'请输入' + getFieldLabelFn(field.key, field.config)"
          ></el-input>

          <el-input
            v-else-if="getFieldModeFn(field.config, field.key) === 'number'"
            v-model.trim="customer[field.key]"
            type="number"
            :placeholder="'请输入' + getFieldLabelFn(field.key, field.config)"
          ></el-input>

          <el-input
            v-else-if="getFieldModeFn(field.config, field.key) === 'textarea'"
            v-model.trim="customer[field.key]"
            type="textarea"
            :rows="3"
            :placeholder="'请输入' + getFieldLabelFn(field.key, field.config)"
          ></el-input>

          <el-date-picker
            v-else-if="getFieldModeFn(field.config, field.key) === 'date'"
            v-model="customer[field.key]"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择日期"
            style="width: 100%;"
          ></el-date-picker>

          <el-time-picker
            v-else-if="getFieldModeFn(field.config, field.key) === 'time'"
            v-model="customer[field.key]"
            value-format="HH:mm:ss"
            placeholder="请选择时间"
            style="width: 100%;"
          ></el-time-picker>

          <el-switch
            v-else-if="getFieldModeFn(field.config, field.key) === 'boolean'"
            v-model="customer[field.key]"
            :active-value="true"
            :inactive-value="false"
          ></el-switch>

          <el-select
            v-else
            v-model="customer[field.key]"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in getFieldOptionsFn(field.config, field.key)"
              :key="'support-opt-' + index + '-' + field.key + '-' + getOptionValueFn(item)"
              :label="getOptionLabelFn(item)"
              :value="getOptionValueFn(item)"
            />
          </el-select>
        </div>

          <div
            v-else-if="isContactPhoneFieldFn(customer, field.key)"
            :key="'support-contact-phone-' + index"
            class="form-item form-item--full"
          >
          <label>是否有电话</label>
          <el-radio-group
            :value="getContactPhoneEnabledFn(customer)"
            @input="setContactPhoneEnabledFn(customer, $event)"
          >
            <el-radio :label="true">有</el-radio>
            <el-radio :label="false">没有</el-radio>
          </el-radio-group>

          <div v-if="getContactPhoneEnabledFn(customer)" class="inline-field inline-field--stack">
            <el-select
              v-model="customer.tel_country_code"
              filterable
              placeholder="选择区号"
            >
              <el-option
                v-for="item in getFieldOptionsFn(getCustomFieldConfigFn('tel_country_code'), 'tel_country_code')"
                :key="'support-contact-tel-code-' + index + '-' + getOptionValueFn(item)"
                :label="getOptionLabelFn(item)"
                :value="getOptionValueFn(item)"
              />
            </el-select>
            <el-input
              v-model.trim="customer.tel_number"
              placeholder="请输入联系电话"
            ></el-input>
          </div>
        </div>

          <div
            v-else-if="isContactAppFieldFn(customer, field.key)"
            :key="'support-contact-app-' + index"
            class="form-item form-item--full"
          >
          <label>是否有通讯软件</label>
          <el-radio-group
            :value="getContactAppEnabledFn(customer)"
            @input="setContactAppEnabledFn(customer, $event)"
          >
            <el-radio :label="true">有</el-radio>
            <el-radio :label="false">没有</el-radio>
          </el-radio-group>

          <div v-if="getContactAppEnabledFn(customer)" class="stack-field">
            <div class="form-subitem">
              <label>{{ getFieldLabelFn('contact_app', getCustomFieldConfigFn('contact_app')) }}<span class="required">*</span></label>
              <el-select
                v-model="customer.contact_app"
                filterable
                placeholder="请选择通讯软件"
              >
                <el-option
                  v-for="item in getSupportedContactAppsFn()"
                  :key="'support-contact-app-option-' + index + '-' + getOptionValueFn(item)"
                  :label="getOptionLabelFn(item)"
                  :value="getContactAppOptionValueFn(item)"
                />
              </el-select>
            </div>
            <div class="form-subitem">
              <label>{{ getFieldLabelFn('contact_app_account', getCustomFieldConfigFn('contact_app_account')) }}<span class="required">*</span></label>
              <el-input
                v-model.trim="customer.contact_app_account"
                placeholder="请输入通讯软件账号"
              ></el-input>
            </div>
          </div>
        </div>

          <div
            v-else
            :key="'support-country-' + index + '-' + field.key"
            class="form-item form-item--full"
          >
          <label>{{ getFieldLabelFn(field.key, field.config) }}<span v-if="isRequiredFn(field.config)" class="required">*</span></label>
          <div class="inline-field">
            <el-select
              :value="getCountryParentFn(customer, getCustomerIndexFn(customer))"
              filterable
              placeholder="选择国家/地区"
              @input="setCountryParentFn(customer, getCustomerIndexFn(customer), $event)"
            >
              <el-option
                v-for="item in getFieldOptionsFn(field.config, field.key)"
                :key="'support-country-parent-' + index + '-' + item.id"
                :label="getOptionLabelFn(item)"
                :value="String(item.id)"
              />
            </el-select>
            <el-select
              v-model="customer[field.key]"
              filterable
              placeholder="选择城市"
            >
              <el-option
                v-for="city in getCountryCitiesFn(customer, getCustomerIndexFn(customer), field.config)"
                :key="'support-country-city-' + index + '-' + city.city_code"
                :label="city.name"
                :value="city.city_code"
              />
            </el-select>
          </div>
          </div>
        </template>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ShopOrderContactSection',
  props: {
    supportCustomers: { type: Array, required: true },
    getCustomerTitleFn: { type: Function, required: true },
    getVisibleCustomFieldsFn: { type: Function, required: true },
    getFieldModeFn: { type: Function, required: true },
    isWideFieldFn: { type: Function, required: true },
    getFieldLabelFn: { type: Function, required: true },
    isRequiredFn: { type: Function, required: true },
    getFieldOptionsFn: { type: Function, required: true },
    getOptionValueFn: { type: Function, required: true },
    getOptionLabelFn: { type: Function, required: true },
    getCountryParentFn: { type: Function, required: true },
    getCustomerIndexFn: { type: Function, required: true },
    setCountryParentFn: { type: Function, required: true },
    getCountryCitiesFn: { type: Function, required: true },
    isContactPhoneFieldFn: { type: Function, required: true },
    isContactAppFieldFn: { type: Function, required: true },
    shouldSkipSupportFieldFn: { type: Function, required: true },
    getContactPhoneEnabledFn: { type: Function, required: true },
    setContactPhoneEnabledFn: { type: Function, required: true },
    getCustomFieldConfigFn: { type: Function, required: true },
    getContactAppEnabledFn: { type: Function, required: true },
    setContactAppEnabledFn: { type: Function, required: true },
    getSupportedContactAppsFn: { type: Function, required: true },
    getContactAppOptionValueFn: { type: Function, required: true },
  },
};
</script>

<style scoped>
@import './shopOrderSection.css';
</style>



// WEBPACK FOOTER //
// src/pages/shop/components/ShopOrderContactSection.vue